import React from 'react';
import ListItem from 'material-ui/List/ListItem';
import Avatar from 'material-ui/Avatar';
import { injectIntl } from 'react-intl';
import NotInterestedIcon from '@material-ui/icons/NotInterested';

const CustomerRow = (props) => {
  const getAvatarLabel = () => {
    const nameArr = props.customer.deliverToCustomerName.split(' ');

    return `${nameArr[0]?.[0]}${nameArr[1]?.[0] || ''}`;
  };

  return (
    <ListItem
      onClick={props.handleClick}
      disabled={props.disabled || props.disabledNoFeedback}
      style={props.disabled ? { background: '#EEEEEE' } : {}}
      rightIcon={props.disabled ? <NotInterestedIcon htmlColor="grey" /> : null}
      leftAvatar={<Avatar>{getAvatarLabel()}</Avatar>}
      primaryText={
        <div>
          <div>{props.customer.deliverToCustomerName}</div>
          <div>{props.customer.deliverToStreet}</div>
          <div>{props.customer.deliverToStreet2}</div>
          <div>
            {props.customer.deliverToCity}, {props.customer.deliverToState}
          </div>
        </div>
      }
      secondaryText={
        <div>
          {props.intl.formatMessage({
            id: 'customer_number'
          })}
          : {props.customer.deliverToCustomerNumber} <b>{props.customer.mrsCustomer?.minDeliveryScheduleDesc || ''}</b>
        </div>
      }
    />
  );
};

export default injectIntl(CustomerRow);
